import { EventEmitter } from 'events'
import { isTokenExpired } from './JwtUtil'

export default class AuthService extends EventEmitter {

  constructor() {
    super()

    this.login = this.login.bind( this )
    this.signup = this.signup.bind( this )
  }

  login( params, onError ) {   
    setTimeout( onError, 1, { status : 500, message : 'not implemented' } )
  }

  signup( params, onError ) {
    setTimeout( onError, 1, { status : 500, message : 'not implemented' } )
  }

  parseHash( hash, cb ) {

    console.log( 'AuthService.parseHash', hash );
    
    setTimeout( cb, 1, { status : 500, message : 'not implemented' } )
    return false
  }

  supportsSignup( ) {
    return false
  }
  
  supportsGoogleLogin( ) {
    return false
  }

  isLoggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken()
    try {
      const r = !!token && !isTokenExpired( token )
      if ( !r ) {
        this.setToken( null )
      }
      return r
    } catch ( err ) {
      return false
    }
  }

  setProfile( profile ) {
    // Saves profile data to localStorage
    localStorage.setItem( 'profile', JSON.stringify( profile ) )
    // Triggers profile_updated event to update the UI
    this.emit( 'profile_updated', profile )
  }

  getProfile() {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem( 'profile' )
    return profile ? JSON.parse( localStorage.profile ) : {}
  }

  setToken( idToken ) {
    // Saves user token to localStorage
    if ( idToken == null ) {
      localStorage.removeItem( 'id_token' )
    } else {
      localStorage.setItem( 'id_token', idToken )
    }
  }

  getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem( 'id_token' )
  }

  // setState( state ) {
  //   localStorage.setItem( "auth_state", state );
  // }

  // getState() {
  //   return localStorage.getItem( "auth_state" );
  // }

  setReturnToPath( path ) {
    if ( path == null ) {
      localStorage.removeItem( 'returnToPath' );
    } else { 
      localStorage.setItem( 'returnToPath', path );
    }
  }

  getReturnToPath( ) {
    return localStorage.getItem( 'returnToPath' );
  }

  logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem( 'id_token' );
    localStorage.removeItem( 'profile' );

    window.location.href = '/'
  }

}
